module.exports = __webpack_public_path__ + "img/pcBanner10.79f30ace.png";